<template>
    <div class="project-list-page h100">
        <van-search
            v-model="filter"
            placeholder="请输入搜索关键词"
            @search="onSearch"
        />
        <van-tabs v-model="active" @change="tabChange">
            <van-tab
                v-for="(item, index) in type"
                :key="item.label"
                :title="item.label"
            >
                <base-list
                    :ref="`baseList${index}`"
                    :api="getApi"
                    :mapping-data="mappingData"
                    :filter="{ ...item.filter, filter }"
                >
                    <template v-slot:default="scope">
                        <project-item :data="scope.data" @handleClick="checkDetail" />
                    </template>
                </base-list>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import { Search, Tab, Tabs } from 'vant'
    import baseList from '@/components/baseList'
    import projectItem from '@/components/projectItem'
    const {
        projectApi,
        mixin,
        type,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/project`)
    export default {
        name: 'ProjectList',
        components: {
            [Search.name]: Search,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            baseList,
            projectItem,
        },
        mixins: [mixin],
        data() {
            return {
                filter: '',
                active: 0,
                getApi: projectApi,
                type,
            }
        },
        methods: {
            onSearch() {
                this.$refs[`baseList${this.active}`][0].refresh()
            },
            checkDetail(item) {
                this.$router.push({
                    name: 'ProjectDetail',
                    query: {
                        id: item.id,
                        title: '项目详情',
                    },
                })
            },
            tabChange() {
                if (this.typeChange) {
                    this.typeChange()
                }
            },
        },
    }
</script>

<style lang="scss">
@import "../../assets/style/projectList.scss";
.project-list-page {
  background: url("../../assets/images/background/xiangmubeijin.png") no-repeat 0
    100px;
  background-position: 0px -90px;
  background-size: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .van-search {
    background: none;
  }
  .van-tabs {
    border-radius: 10px 10px 0 0;
    background: #ffffff;
    flex: 1;
    .van-tabs__wrap {
      border-radius: 10px 10px 0 0;
    }
  }
  .van-tab {
    flex: 0 0 auto !important;
    padding: 0px 10px;
  }
  .van-tabs__line {
    background-color: rgba(0, 146, 63, 1) !important;
    height: 2px !important;
  }
}
</style>
